import { ShieldCheck, Clock, MapPinned, FileCheck } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import QuoteCalculator from "@/components/QuoteCalculator";

const Calculateur = () => (
  <>
    <Seo
      title="Calculateur de devis transport — Estimation immédiate | ASTROLOG"
      description="Estimez le prix de votre transport routier en quelques secondes : distance, poids, type de camion. Fourchette de prix indicative, devis précis sous 24 h ouvrées."
      path="/calculateur"
    />

    <section className="brand-dark noise relative py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <h1 className="font-heading text-4xl font-bold tracking-tighter text-[#FAFAF7] sm:text-5xl">
            Calculateur de devis transport
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-300">
            Estimez instantanément une fourchette de prix à partir de la
            distance, du poids de votre marchandise et du calibre du camion.
            Gratuit, sans engagement, aucune donnée transmise sans votre accord.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-16" data-testid="calculator-page-section">
      <Reveal>
        <QuoteCalculator variant="full" />
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2">
        {[
          { icon: Clock, title: "Devis sous 24 h ouvrées", text: "Toute demande reçoit une réponse chiffrée en moins de 24 heures ouvrées." },
          { icon: ShieldCheck, title: "Marchandises assurées", text: "Assurance marchandises transportées AXA France IARD, France et UE." },
          { icon: MapPinned, title: "France et Europe", text: "Benelux, Allemagne, Espagne, Italie, Portugal, Suisse — et au-delà sur demande." },
          { icon: FileCheck, title: "Estimation sans engagement", text: "La fourchette affichée est indicative : seul le devis écrit fait foi (valable 15 jours)." },
        ].map((item, i) => (
          <Reveal key={item.title} delay={i * 80}>
            <div className="flex h-full gap-4 rounded-2xl border border-slate-200 bg-white p-6">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10">
                <item.icon className="h-6 w-6 text-primary" strokeWidth={1.75} />
              </span>
              <div>
                <h2 className="font-heading text-base font-semibold">{item.title}</h2>
                <p className="mt-1 text-sm leading-relaxed text-slate-600">{item.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </>
);

export default Calculateur;
